import * as React from 'react'
import { ReactNode } from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Collapse from '@mui/material/Collapse'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'

type Faq = {
    question: string
    answer: string | ReactNode
}

    type Props = {
    faqs: Faq[]
    className?: string
    }

    const FaqList = ({ faqs, className }: Props) => {
    const [openIndex, setOpenIndex] = React.useState<number | null>(null)

    const handleToggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <List className={`container_question ${className || ""}`}>
            {faqs.map((faq, index) => (
                <React.Fragment key={index}>
                <div key={index} className='faq-item'>    
                {/* Pregunta */}
                <ListItemButton onClick={() => handleToggle(index)} className="question_item">
                        <ListItemText primary={faq.question} className="question_text"/>                    
                        {openIndex === index ? <ExpandLess /> : <ExpandMore />}                   
                </ListItemButton>
                {/* Respuesta */}
                <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem sx={{ pl: 4 }}>
                            <ListItemText className="answer_text">
                                {faq.answer}
                            </ListItemText>
                        </ListItem>
                    </List>
                </Collapse>
                </div>
                <div className={`separator ${openIndex === index ? 'hidden-separator' : ''}`} />
                </React.Fragment>
            ))}
        </List>
    )
}

export default FaqList
